import { UPDATE_REPORTS_LOADING_STATUSES } from '../constants/actionTypes';
import { CANCEL_APPLICATION_MANAGER_IDV_REQUEST } from '../constants/actions';

const initState = () => ({
  creditReportLoading: false,
  backgroundReportLoading: false,
});

function reportsLoadingStatuses(state = initState(), action = {}) {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_REPORTS_LOADING_STATUSES:
      return { ...state, ...payload };
    case CANCEL_APPLICATION_MANAGER_IDV_REQUEST:
      return {
        creditReportLoading: false,
        backgroundReportLoading: false,
      };
    default:
      return state;
  }
}

export default reportsLoadingStatuses;
